// Small formatting + error helpers shared by the Damage Entry and Stock Report screens.

export const formatQuantity = (quantity) =>
    Number(quantity || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const formatUnit = (unit) => {
    if (!unit) return "";
    const clean = unit.toString().toLowerCase();
    return clean.charAt(0).toUpperCase() + clean.slice(1);
};

// Allows "", "12", "12.", "12.5" — blocks letters, minus, double dots.
export const isValidQuantityInput = (value) => /^\d*\.?\d*$/.test(value);

// Local-date "YYYY-MM-DD" (toISOString would shift the day for IST users).
export const toISODate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
};

// The backend returns errors in a few shapes depending on the status code
// (406 / 412 / 404 / 500), so look in all the usual places.
export const getErrorMessage = (err, fallback = "Something went wrong. Please try again.") => {
    const data = err?.response?.data;
    const candidates = [
        data?.error?.message,
        data?.error,
        data?.data?.message,
        data?.message,
    ];
    const found = candidates.find((value) => typeof value === "string" && value.trim());
    return found || (err?.response ? fallback : err?.message) || fallback;
};